import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import LogisticLoadListItemRestModel from "../../models/rest/logistic/logisticLoadListItemRestModel";
import LogisticLoadBidRestModel from "../../models/rest/logistic/logisticLoadBidRestModel";

@Component
export default class LogisticLoadBidDialog extends Vue {
    @Prop({ type: Boolean, required: true })
    value!: boolean;

    @Prop({ type: Object, default: null })
    loadItem!: LogisticLoadListItemRestModel | null;

    logisticLoadBid = {} as LogisticLoadBidRestModel;
    offeredPriceCurrency = "EUR";

    get currentUserContractorId(): number {
        return this.$store.direct.state.auth.currentUserContractorId;
    }

    @Watch("loadItem")
    onLoadItemChanged() {
        this.logisticLoadBid = {
            offeredPriceCurrency: this.offeredPriceCurrency,
        } as LogisticLoadBidRestModel;
    }

    closeDialog() {
        this.$emit('input', false);
    }

    async submitBid() {
        const form = this.$refs.bidForm as Vue & { validate: () => boolean };
        if (!form.validate() || !this.loadItem) {
            return;
        }

        this.logisticLoadBid.loadId = this.loadItem.id;
        this.logisticLoadBid.carrierId = this.currentUserContractorId;

        this.$emit('submit-bid', this.logisticLoadBid);
    }

    allowNumbersOnly(evt: any) {
        return this.$store.direct.dispatch.settlementCommon.allowNumbersOnly(evt);
    }
}